import React from 'react'
import { Link } from 'react-router-dom'
import { SwiperCarousel, ButtonOutline } from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils';
import data from '../../../database/resources.json'
const featureds = data.filter(d => d.featured === true).slice(0, 6)

const Carousel = ({isMobile}) => {
  return (
    <div className="-mx-2 lg:-mx-4 text-gray-900 mb-5 lg:mb-0">
      <SwiperCarousel breakpoints={{
        [viewportBreakpoint.desktop] : {
          slidesPerView: 6
        }
      }}>
        {
          featureds.map((d, index) => (
            <div className="w-1/2 lg:w-1/6 px-2 lg:px-4 mb-4" key={index}>
              <Link to={`/resource/detail/${d.id}`}>
                {
                  isMobile ? (
                    <CardMobile data={d}/>
                  ) : (
                    <Card data={d}/>
                  )
                }
              </Link>
            </div>
          ))
        }
      </SwiperCarousel>
    </div>
  )
}

const Cards = ({isMobile}) => {
  return (
    <div className="flex flex-wrap -mx-2 lg:-mx-4 text-gray-900 mb-5 lg:mb-12">
      {
        featureds.map((d, index) => (
          <div className="w-1/2 lg:w-1/6 px-2 lg:px-4 mb-4" key={index}>
            <Link to={`/resource/detail/${d.id}`}>
              {
                isMobile ? (
                  <CardMobile data={d}/>
                ) : (
                  <Card data={d}/>
                )
              }
            </Link>
          </div>
        ))
      }
    </div>
  )
}

const Card = ({data}) => {
  return (
    <div className="p-4 h-full rounded shadow shadow-md">
      <div
        className="bg-no-repeat bg-cover mb-4 bg-center w-full rounded"
        style={{height: '130px', minWidth: '100%', backgroundImage: `url('${data.image}')`}}
      />
      <div>
        <p className="text-gray-500 text-xs mb-2">{data.category} /
          {data.organization}</p>
        <h3 className="mb-2 font-bold text-sm font-primary">{data.title}</h3>
      </div>
    </div>
  )
}

const CardMobile = ({data}) => {
  return (
    <div className="p-3 h-full rounded shadow shadow-md">
      <div
        className="bg-no-repeat bg-cover mb-3 bg-center w-full rounded"
        style={{height: '105px', minWidth: '100%', backgroundImage: `url('${data.image}')`}}
      />
      <div>
        <p className="text-gray-500 mb-2" style={{fontSize: '9px'}}>{data.category} /
          {data.organization}</p>
        <h3 className="font-bold text-xs font-primary">{data.title}</h3>
      </div>
    </div>
  )
}

const SectionResources = () => {
  const { width } = useViewport();
  const breakpoint = viewportBreakpoint.tablet;
  const isMobile = width < breakpoint;
  const withCarousel = false;

  return (
    <div className="py-16 lg:py-24 bg-white">
      <div className="container mx-auto overflow-hidden">
        <div className="flex justify-center items-center mb-6 lg:mb-16">
          <h1 className="text-2xl lg:text-4xl uppercase">Featured Resources</h1>
        </div>

        {
          !withCarousel &&
          <Cards isMobile={isMobile}/>
        }
        {
          withCarousel &&
          <Carousel isMobile={isMobile}/>
        }

        <div className="flex justify-center items-center w-full">
          <Link to="/resource">
            <ButtonOutline outlineColor="primary" className="border-2 py-1 px-5 font-bold text-primary">
              Lihat lainnya
            </ButtonOutline>
          </Link>
        </div>

        {/* <div className="lg:hidden w-full">
          <Link to="/resource">
            <p className="block text-center uppercase font-bold text-sm px-2 py-1 border-2 border-gray-400 rounded font-accent">
              View More
            </p>
          </Link>
        </div> */}
      </div>
    </div>
  )
}

export { SectionResources }
